// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/g-force-physiology.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/g-force-physiology/g-force-physiology.js';
import g1 from '../lessons/aeronautics/g-force-physiology/g-jolt.js';
import g2 from '../lessons/aeronautics/g-force-physiology/g-turbulence-loads.js';

mount([g0, g1, g2]);
